import { Icon } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import './styles.scss';

let Tooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  t,
}) => (
  <div {...tooltipProps} className="info-window">
    <label className="info-description">{step.content}</label>
    {continuous && (
      <label {...primaryProps} className="info-button">
        {t('actions.got_it').toUpperCase()}
      </label>
    )}
  </div>
);

export const BeaconComponent = (props) => (
  <Icon circular name="info" className="info-pulse" {...props} />
);

// Wrap components with withTranslation HOC
Tooltip = withTranslation()(Tooltip);
export { Tooltip };
